import React from 'react';
import './scss/style.scss';
import Routing from './view/router';

function App() {
  return (
    <Routing />
  );
}

export default App;
